export default "* Bue\n* Pil\n* Våben\n* Jagt\n";